<template>
    <div style="cursor: pointer; user-select: none" class="columns-row">
        <div class="columns_img img-scale-in" :class="{'lower-opacity': !selected}">
            <a>
                <img v-if="debate.author.blob != null" style="width: 80px" :src="debate.author.blob.url" alt=""/>
            </a>
        </div>
        <div class="columns_content" :class="{'lower-opacity': !selected}">
            <h2>
                <a>
                    <b>{{ debate.author.author_languages[0].pivot.name }}</b>
                </a>
            </h2>
            <span style="color: black">{{ debate.debate_languages[0].pivot.title }}</span>
        </div>
    </div>

</template>

<script>
export default {
    name: "DebatersArticleSelectable",
    props: {
        article: {
            type: Object,
            default: null
        },
        debate: {
            type: Object,
            default: null
        },
        selected: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date(this.debate.created_at.replace(' ', 'T'));
            const options = {month: 'short', day: 'numeric', year: 'numeric'};
            return date.toLocaleDateString(this.$store.state.language.code === 'ar' ? 'ar-LB' : 'en-US', options).toUpperCase();
        }
    }
}
</script>

<style scoped>
.lower-opacity {
    opacity: 0.5;
}
</style>
